import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";


import { createUseStyles } from "react-jss";

import AuthNavbar from "components/Navigation/Navbars/Auth/AuthNavbar";

import { dashRoutes as routes } from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/customerStyle";
import Footer from "components/Sales/Footer";
//import Banner from "components/Sales/Banner";

const useStyles = createUseStyles(styles);

export default function CustomerLayout(props) {
  const classes = useStyles();
  const { setSnackbar, ...rest } = props;

  const getRoutes = (routes) => {
    return routes
      .filter((route) => route.layout === "/customer")
      .map((prop, key) => {
        if (prop.collapse) {
          return getRoutes(prop.views);
        }

        return (
          <Route
            path={prop.path}
            key={key}
            element={
              <prop.component
                key={prop.layout + prop.path}
                {...props}
                setSnackbar={setSnackbar}
              />
            }
          />
        );
      });
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.fullPage}>
        <AuthNavbar {...rest} shrinkOnValue={275} />

        <div className={classes.content}>
          <Routes>
            {getRoutes(routes)}
            <Route path="/" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </div>
  );
}
